import type { ComboboxItem } from '@any-ui-react/core';
import type { QueryHookOptions, QueryResult } from '@apollo/client';
import get from 'lodash-es/get';

interface ComboboxData {
  id: string;
  name: string;
  enabled: boolean;
}

export const useGetComboboxData = <TData>(
  // `any` for the query variables: this hook is called with each entity's own generated query hook
  // (e.g. useListEpmMasterVddsQuery), each with a differently-shaped variables type that isn't worth
  // threading through a second generic parameter for a hook this small.
  queryFunc: (baseOptions?: QueryHookOptions<TData, any>) => QueryResult<TData, any>,
  key: keyof Omit<TData, '__typename'>,
): {
  loading: boolean;
  options: Array<ComboboxItem>;
} => {
  const { data, loading } = queryFunc({ fetchPolicy: 'cache-first' });
  const items = get(data, `${String(key)}.items`, []) as Array<ComboboxData>;
  return {
    loading,
    options: items.map(d => ({ value: d.id, label: d.name, disabled: !d.enabled }) as ComboboxItem),
  };
};
